import React, {useEffect} from 'react';
import {Helmet} from 'react-helmet-async';

const PrivacyPolicy = () => {
  useEffect(() => {
    // Load Iubenda script
    const loader = function() {
      const s = document.createElement("script");
      const tag = document.getElementsByTagName("script")[0];
      s.src = "https://cdn.iubenda.com/iubenda.js";
      tag.parentNode.insertBefore(s, tag);
    };
    
    if (window.addEventListener) {
      window.addEventListener("load", loader, false);
    } else if (window.attachEvent) {
      window.attachEvent("onload", loader);
    } else {
      window.onload = loader;
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy - Realizzazione Siti Web Napoli</title>
        <meta name="description" content="Privacy Policy di Realizzazione Siti Web Napoli. Informazioni sul trattamento dei dati personali." />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href="https://realizzazionesitiweb-napoli.it/privacy" />
      </Helmet>
      <div className="pt-24 min-h-screen bg-white">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-8 text-center mt-12 md:mt-0">
              Privacy Policy
            </h1>
            <div className="bg-napoli-light rounded-xl p-8">
              <a href="https://www.iubenda.com/privacy-policy/62245103" className="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Privacy Policy">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;